export default __webpack_public_path__ + "static/media/icon-highlight.bf97b770.svg";